export const SITE_URL = 'https://carxpert.co.uk/';
export const BLOG_URL = `${SITE_URL}recent-posts/`;
export const CONTACTS_URL = `${SITE_URL}about/`;